import { goRequest } from '../utils/httpClientTs';

export interface InterestGroup {
  id: string;
  name: string;
  description: string;
  role: 'none' | 'follower' | 'manager' | string;
}

export interface InterestGroupPerson {
  user_id: string;
  name: string;
}

export interface InterestGroupProposal {
  id: string;
  name: string;
  description: string;
  status: string;
  suggested_by_id: string;
  suggested_by_name: string;
  group_id?: string;
  review_note?: string;
  created_at: string;
  managers: InterestGroupPerson[];
  interested: InterestGroupPerson[];
  can_review: boolean;
  is_interested: boolean;
  is_manager: boolean;
}

export interface InterestGroupProposalList {
  can_review: boolean;
  proposals: InterestGroupProposal[];
}

export interface CreateInterestGroupProposal {
  name: string;
  description: string;
  manager_ids: string[];
  interested_ids: string[];
}

export const getInterestGroups = (): Promise<InterestGroup[]> =>
  goRequest<InterestGroup[]>({ url: '/interest-groups', method: 'GET' });

export const getInterestGroupProposals =
  (): Promise<InterestGroupProposalList> =>
    goRequest<InterestGroupProposalList>({
      url: '/interest-groups/proposals',
      method: 'GET',
    });

export const createInterestGroupProposal = (
  body: CreateInterestGroupProposal
): Promise<{ id: string }> =>
  goRequest({ url: '/interest-groups/proposals', method: 'POST', data: body });

export const followInterestGroup = (id: string): Promise<unknown> =>
  goRequest({ url: `/interest-groups/${id}/follow`, method: 'POST' });

export const leaveInterestGroup = (id: string): Promise<unknown> =>
  goRequest({ url: `/interest-groups/${id}/leave`, method: 'POST' });

export const addProposalInterest = (id: string): Promise<unknown> =>
  goRequest({
    url: `/interest-groups/proposals/${id}/interest`,
    method: 'POST',
  });

export const removeProposalInterest = (id: string): Promise<unknown> =>
  goRequest({
    url: `/interest-groups/proposals/${id}/interest`,
    method: 'DELETE',
  });

export const acceptInterestGroupProposal = (
  id: string
): Promise<{ id: string }> =>
  goRequest({
    url: `/interest-groups/proposals/${id}/accept`,
    method: 'POST',
  });

export const rejectInterestGroupProposal = (
  id: string,
  note: string
): Promise<unknown> =>
  goRequest({
    url: `/interest-groups/proposals/${id}/reject`,
    method: 'POST',
    data: { note },
  });
